import styled from "@emotion/styled";
import { Card, Colors, Fonts } from "@snapchat/snap-design-system";

import { Flexbox } from "../../core/components";

export const FullPageErrorContainer = styled(Flexbox)`
    background-color: #f7f7f7;
`;

export const ErrorInfoCard = styled(Card)`
    width: 70%;
`;

export const ErrorTitle = styled.span`
    margin: 40px 0 16px;
    ${Fonts.Heading.H400}
`;

export const Description = styled.span`
    ${Fonts.Paragraph.P200}
    margin-bottom: 24px;
    color: ${Colors.Black.V50};
`;
